import axios from "axios";
import { showCustomToast } from "./toastUtil";

export function imageHandler(e, quillRef) {
  // Create a file input
  const input = document.createElement("input");
  input.setAttribute("type", "file");
  input.setAttribute("accept", "image/*");
  input.click();

  // When a file is selected
  input.onchange = async () => {
    const file = input.files[0];
    const allowedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "image/heic",
      "image/heif",
      "image/webp",
      "image/avif",
    ];

    if (!allowedTypes.includes(file.type)) {
      showCustomToast(
        "الملف الذي حاولت رفعة غير مدعم الرجاء اختيار احد الأمتدادات التالية : (jpg, jpeg, png, gif, heic, heif, webp, avif)",
        "error"
      );
      return;
    }
    if (file.size > 8000000) {
      showCustomToast("الرجاء اختيار صورة بحد اقصي 5 ميقا بايت", "error");
      return;
    }
    if (file && /^image\//.test(file.type)) {
      const formData = new FormData();
      formData.append("type", "composer");
      formData.append("synchronous", "true"); // Note: if your API expects a boolean, ensure this conversion is handled properly
      formData.append("file", file);

      // Define your upload endpoint
      const uploadUrl = `${process.env.REACT_APP_API_URL}/uploads.json`;

      try {
        // Upload the image without manually setting the Content-Type header
        const response = await axios.post(uploadUrl, formData);
        let imageUrl = response.data.url;
        // Prepend http: if the URL starts with //
        if (imageUrl.startsWith("//")) {
          imageUrl = `http:${imageUrl}`;
        }
        // Get the underlying Quill instance
        const quill = quillRef.current.getEditor();
        if (!quill) {
          console.error("Quill instance not found.");
          return;
        }
        const range = quill.getSelection();
        if (range) {
          quill.insertEmbed(range.index, "image", imageUrl);
        } else {
          // Optionally, handle when there is no selection (for example, appending at the end)
          quill.insertEmbed(quill.getLength(), "image", imageUrl);
        }
      } catch (err) {
        console.error("Image upload failed:", err);
      }
    } else {
      console.error("Only image files are allowed.");
    }
  };
}

export const getQuillModules = (quillRef, imageHandler) => ({
  toolbar: {
    container: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["image", "link"],
      [
        {
          color: [
            "#000000",
            "#e60000",
            "#ff9900",
            "#ffff00",
            "#008a00",
            "#0066cc",
            "#9933ff",
            "#ffffff",
            "#facccc",
            "#ffebcc",
            "#ffffcc",
            "#cce8cc",
            "#cce0f5",
            "#ebd6ff",
            "#bbbbbb",
            "#f06666",
            "#ffc266",
            "#ffff66",
            "#66b966",
            "#66a3e0",
            "#c285ff",
            "#888888",
            "#a10000",
            "#b26b00",
            "#b2b200",
            "#006100",
            "#002966",
            "#3d1466",
          ],
        },
      ],
    ],
    handlers: {
      image: (e) => imageHandler(e, quillRef),
    },
  },
  mention: {
    blotName: "mention",
    allowedChars: /^[A-Za-z\u0600-\u06FF\sÅÄÖåäö]*$/,
    mentionDenotationChars: ["@"],
    spaceAfterInsert: true,
    renderItem: function (item, searchTerm) {
      const avatarUrl = item.avatar_template.replace("{size}", "40");
      return `
        <div id="${item.id}" style="display: flex; align-items: center; cursor: pointer;" 
             class="mention-item">
          <img src="https://community.salla.com/${avatarUrl}" 
               alt="${item.value}" 
               style="width:25px; height:25px; border-radius:50%; margin-left:10px;" />
          <span>${item.name} (${item.value})</span>
        </div>
      `;
    },
    source: function (searchTerm, renderList, mentionChar) {
      if (searchTerm.length === 0) {
        renderList([], searchTerm);
        return;
      }

      const url = `${
        process.env.REACT_APP_API_URL
      }/u/search/users.json?term=${encodeURIComponent(
        searchTerm
      )}&include_groups=true&limit=6`;

      axios
        .get(url)
        .then((response) => {
          const users = response.data.users || [];
          const values = users.map((user) => ({
            id: user.id,
            value: user.username,
            name: user.name,
            avatar_template: user.avatar_template,
          }));

          // Pass the list and bind the selection event correctly
          renderList(values, searchTerm);
        })
        .catch((error) => {
          console.error("Error fetching users:", error);
          renderList([], searchTerm);
        });
    },
    onSelect: function (item, insertItem) {
      insertItem(item);
    },
  },
});
